const STANDARD = "STANDARD";

const $inject = [
  "$scope",
  "$rootScope",
  "ClinicRelationshipsService",
  "PhpPolyfillObject",
  "relationships",
];

class ClinicRelationshipController {
  constructor(
    $scope,
    $rootScope,
    ClinicRelationshipsService,
    PhpPolyfillObject,
    relationships
  ) {
    this.$scope = $scope;
    this.ClinicRelationshipsService = ClinicRelationshipsService;
    this.PhpPolyfillObject = PhpPolyfillObject;

    $scope.show_toast = function ($message, $class) {
      $rootScope.$emit("display-toast", $message, $class);
    };

    $scope.hide_toast = function () {
      $rootScope.$emit("remove-toast");
    };

    $scope.clinic = relationships.data.clinic;
    $scope.gps = relationships.data.clinic.gps;
    $scope.pharmacists = relationships.data.pharmacists;
    $scope.relationships = relationships.data.relationships;
    $scope.relationship_types = relationships.data.relationship_types;

    $scope.current = "clinic";

    this.any_gp = {id: null};
    $scope.gps.forEach(gp => gp.group = "Individual GPs");
    $scope.gps.splice(0, 0, this.any_gp);

    this.any_pharmacist = {id: null};
    $scope.pharmacists.forEach(pharmacist => pharmacist.group = "Individual Pharmacists");
    $scope.pharmacists.splice(0, 0, this.any_pharmacist);

    $scope.no_relationship_type = {id: null};
    $scope.relationship_types.forEach(relationship_type => relationship_type.group = "Relationship Types");
    $scope.relationship_types.splice(0, 0, $scope.no_relationship_type);
    this.connect_relationships();
    this.validate_rules();
  }

  save_relationships() {
    let self = this;

    this.$scope.saving = true;

    let keys_to_save = {
      id: true,
      clinic: true,
      gp: true,
      pharmacist: true,
      relationship_type: true,
      reason: true,
    };

    let data = {
      relationships: this.$scope.relationships
        .map(function (value) {
          let result = self.PhpPolyfillObject.new();
          if (!value.deleted) {
            result = Object.assign(result, value);
            for (let key of ["clinic", "gp", "pharmacist", "relationship_type"]) {
              result[key] = result[key].id;
            }
            delete result.deleted;
          }
          return result.intersectKey(keys_to_save);
        }),
    };

    let handle_success = function (response) {
      self.$scope.saving = false;
      if (!response.data.success) {
        handle_error(response);
      }
      else {
        self.$scope.relationships = response.data.data.relationships;
        self.connect_relationships();
        self.$scope.relationship_form.$setPristine();
        self.$scope.show_toast(response.data.message, "alert-success");
        self.validate_rules();
      }
    };

    let handle_error = function (response) {
      self.$scope.saving = false;
      let error_message;

      if (!response.data || !response.data.message) {
        error_message = "An unexpected server error occurred.";
      }
      else {
        error_message = response.data.message;
      }

      self.$scope.show_toast(error_message, "alert-danger");
    };

    this.ClinicRelationshipsService.save(this.$scope.clinic.id, data, handle_success, handle_error);
  }

  connect_relationships() {
    let self = this;
    this.original_relationships = this.$scope.relationships.map(relationship => {
      return Object.assign({}, relationship);
    });

    let match_rule = function (item) {
      return item.id === (this? this.id: null);
    };

    for (let i = 0; i < this.original_relationships.length; ++i) {
      this.original_relationships[i].gp = this.$scope.gps.find(match_rule, this.original_relationships[i].gp);
      this.original_relationships[i].pharmacist = this.$scope.pharmacists.find(match_rule, this.original_relationships[i].pharmacist);
      this.original_relationships[i].relationship_type = this.$scope.relationship_types.find(match_rule, this.original_relationships[i].relationship_type);
    }

    this.$scope.relationships.forEach(function (relationship) {
      relationship.gp = self.$scope.gps.find(function (gp) {
        return this && gp.id === this.id || !this && !gp.id;
      }, relationship.gp);

      relationship.pharmacist = self.$scope.pharmacists.find(function (pharmacist) {
        return this && pharmacist.id === this.id || !this && !pharmacist.id;
      }, relationship.pharmacist);

      relationship.relationship_type = self.$scope.relationship_types.find(function (relationship_type) {
        return this && relationship_type.id === this.id || !this && !relationship_type.id;
      }, relationship.relationship_type);
    });
  }

  valid() {
    this.check_user_validation();
    return this.$scope.valid;
  }

  invalid() {
    this.check_user_validation();
    return this.$scope.invalid;
  }

  validate_rules() {
    this.$scope.rules = {
      default: [],
      gp: {},
      pharmacist: {},
      specific: {},
    };

    this.$scope.error = [];
    this.$scope.warning = [];

    for (let i in this.$scope.relationships) {
      this.$scope.relationships[i].error = {};
      this.$scope.relationships[i].warning = {};

      let gp_id = this.$scope.relationships[i].gp.id;
      let pharmacist_id = this.$scope.relationships[i].pharmacist.id;

      if (!pharmacist_id) {
        if (!gp_id) {
          this.$scope.rules.default.push(i);
        }
        else {
          if (!this.$scope.rules.gp.hasOwnProperty(gp_id)) {
            this.$scope.rules.gp[gp_id] = [];
          }
          this.$scope.rules.gp[gp_id].push(i);
        }
      }
      else {
        if (!gp_id) {
          if (!this.$scope.rules.pharmacist.hasOwnProperty(pharmacist_id)) {
            this.$scope.rules.pharmacist[pharmacist_id] = [];
          }
          this.$scope.rules.pharmacist[pharmacist_id].push(i);
        }
        else {
          if (!this.$scope.rules.specific.hasOwnProperty(gp_id)) {
            this.$scope.rules.specific[gp_id] = {};
          }
          if (!this.$scope.rules.specific[gp_id].hasOwnProperty(pharmacist_id)) {
            this.$scope.rules.specific[gp_id][pharmacist_id] = [];
          }
          this.$scope.rules.specific[gp_id][pharmacist_id].push(i);
        }
      }
    }

    this.validate_default_rules();
    this.validate_gp_rules();
    this.validate_pharmacist_rules();
    this.validate_specific_rules();

    if (this.$scope.error.length) {
      this.$scope.valid = false;
      this.$scope.invalid = true;
      this.$scope.hide_toast();
    }
    else {
      this.$scope.valid = true;
      this.$scope.invalid = false;
    }
  }

  validate_default_rules() {
    for (let dr of this.$scope.rules.default) {
      let default_rule = this.$scope.relationships[dr];
      if (default_rule.relationship_type.code === STANDARD) {
        this.add_warning(default_rule, "redundantDefault", dr);
      }
    }

    this.validate_duplicate(this.$scope.rules.default);
  }

  validate_gp_rules() {
    for (let gp_id in this.$scope.rules.gp) {
      for (let gr of this.$scope.rules.gp[gp_id]) {
        let gp_rule = this.$scope.relationships[gr];
        if (!this.$scope.rules.default.length) {
          if (gp_rule.relationship_type.code === STANDARD) {
            this.add_warning(gp_rule, "redundantDefault", gr);
          }
        }
        else {
          for (let dr of this.$scope.rules.default) {
            let default_rule = this.$scope.relationships[dr];
            if (gp_rule.relationship_type.code === default_rule.relationship_type.code) {
              this.add_warning(gp_rule, "redundantOverride", dr);
            }
          }
        }
      }

      this.validate_duplicate(this.$scope.rules.gp[gp_id]);
    }
  }

  validate_pharmacist_rules() {
    for (let pharmacist_id in this.$scope.rules.pharmacist) {
      for (let pr of this.$scope.rules.pharmacist[pharmacist_id]) {
        let pharmacist_rule = this.$scope.relationships[pr];
        if (!this.$scope.rules.default.length) {
          if (pharmacist_rule.relationship_type.code === STANDARD) {
            this.add_warning(pharmacist_rule, "redundantDefault", pr);
          }
        }
        else {
          for (let dr of this.$scope.rules.default) {
            let default_rule = this.$scope.relationships[dr];
            if (pharmacist_rule.relationship_type.code === default_rule.relationship_type.code) {
              this.add_warning(pharmacist_rule, "redundantOverride", dr);
            }
          }
        }

        for (let gp_id in this.$scope.rules.gp) {
          for (let gr of this.$scope.rules.gp[gp_id]) {
            let gp_rule = this.$scope.relationships[gr];
            if (pharmacist_rule.relationship_type.code !== gp_rule.relationship_type.code && (
              !this.$scope.rules.specific[gp_id] || !this.$scope.rules.specific[gp_id][pharmacist_id] || !this.$scope.rules.specific[gp_id][pharmacist_id].length
            )) {
              this.add_error(gp_rule, "unresolvable", pr);
              this.add_error(pharmacist_rule, "unresolvable", gr);
            }
          }
        }
      }

      this.validate_duplicate(this.$scope.rules.pharmacist[pharmacist_id]);
    }
  }

  validate_specific_rules() {
    for (let gp_id in this.$scope.rules.specific) {
      for (let pharmacist_id in this.$scope.rules.specific[gp_id]) {
        for (let sr of this.$scope.rules.specific[gp_id][pharmacist_id]) {
          let specific_rule = this.$scope.relationships[sr];
          if (!this.$scope.rules.default.length && (!this.$scope.rules.gp[gp_id] || !this.$scope.rules.gp[gp_id].length) && (!this.$scope.rules.pharmacist[pharmacist_id] || !this.$scope.rules.pharmacist[pharmacist_id].length)) {
            if (specific_rule.relationship_type.code === STANDARD) {
              this.add_warning(specific_rule, "redundantDefault", sr);
            }
          }
          else {
            if (!this.$scope.rules.pharmacist[pharmacist_id] || !this.$scope.rules.pharmacist[pharmacist_id].length) {
              if (!this.$scope.rules.gp[gp_id] || !this.$scope.rules.gp[gp_id].length) {
                for (let dr of this.$scope.rules.default) {
                  let default_rule = this.$scope.relationships[dr];
                  if (specific_rule.relationship_type.code === default_rule.relationship_type.code) {
                    this.add_warning(specific_rule, "redundantOverride", dr);
                  }
                }
              }
              else {
                for (let gr of this.$scope.rules.gp[gp_id]) {
                  let gp_rule = this.$scope.relationships[gr];
                  if (specific_rule.relationship_type.code === gp_rule.relationship_type.code) {
                    this.add_warning(specific_rule, "redundantOverride", gr);
                  }
                }
              }
            }
            else {
              if (!this.$scope.rules.gp[gp_id] || !this.$scope.rules.gp[gp_id].length) {
                for (let pr of this.$scope.rules.pharmacist[pharmacist_id]) {
                  let pharmacist_rule = this.$scope.relationships[pr];
                  if (specific_rule.relationship_type.code === pharmacist_rule.relationship_type.code) {
                    this.add_warning(specific_rule, "redundantOverride", pr);
                  }
                }
              }
              else {
                for (let gr of this.$scope.rules.gp[gp_id]) {
                  let gp_rule = this.$scope.relationships[gr];
                  for (let pr of this.$scope.rules.pharmacist[pharmacist_id]) {
                    let pharmacist_rule = this.$scope.relationships[pr];
                    if (specific_rule.relationship_type.code === gp_rule.relationship_type.code && specific_rule.relationship_type.code === pharmacist_rule.relationship_type.code) {
                      this.add_warning(specific_rule, "redundantOverride", gr);
                      this.add_warning(specific_rule, "redundantOverride", pr);
                    }
                  }
                }
              }
            }
          }
        }

        this.validate_duplicate(this.$scope.rules.specific[gp_id][pharmacist_id]);
      }
    }
  }

  validate_duplicate(rule_set) {
    for (let i = 0; i < rule_set.length - 1; ++i) {
      for (let j = i + 1; j < rule_set.length; ++j) {
        if (this.$scope.relationships[rule_set[i]].relationship_type.code === this.$scope.relationships[rule_set[j]].relationship_type.code) {
          this.add_error(this.$scope.relationships[rule_set[i]], "duplicate", rule_set[j]);
          this.add_error(this.$scope.relationships[rule_set[j]], "duplicate", rule_set[i]);
        }
        else {
          this.add_error(this.$scope.relationships[rule_set[i]], "conflict", rule_set[j]);
          this.add_error(this.$scope.relationships[rule_set[j]], "conflict", rule_set[i]);
        }
      }
    }
  }

  add_error(obj, name, id) {
    if (!obj.error[name]) {
      obj.error[name] = [];
    }
    obj.error[name].push((Number)(id) + 1);

    this.$scope.error.push(obj);
  }

  add_warning(obj, name, id) {
    if (!obj.warning[name]) {
      obj.warning[name] = [];
    }
    obj.warning[name].push((Number)(id) + 1);

    this.$scope.warning.push(obj);
  }

  add_relationship() {
    this.$scope.relationships.push(this.get_new_row());
    this.validate_rules();
  }

  delete_relationship(index) {
    let row = this.get_row(index);
    let row_key_id = this.get_row_key(index, "id");
    if (!this.$scope.relationship_form[row][row_key_id].$modelValue) {
      this.$scope.relationships.splice(index, 1);
      this.check_form();
    }
    else {
      this.$scope.relationships[index].deleted = !this.$scope.relationships[index].deleted;
      this.$scope.relationship_form[row][row_key_id].$setDirty();
      if (!this.$scope.relationships[index].deleted) {
        this.check_original(index, "id");
      }
    }

    this.validate_rules();
  }

  has_issue(relationship) {
    return this.has_error(relationship) || this.has_warning(relationship);
  }

  has_error(relationship) {
    return (Boolean)(relationship.error) && Object.keys(relationship.error).length > 0;
  }

  has_warning(relationship) {
    return (Boolean)(relationship.warning) && Object.keys(relationship.warning).length > 0;
  }

  rule_list(rules) {
    let text;
    if (!rules.length) {
      text = "nothing";
    }
    else if (rules.length === 1) {
      text = "rule " + rules[0];
    }
    else if (rules.length === 2) {
      text = "rules " + rules[0] + " and " + rules[1];
    }
    else {
      let last_rule = rules.pop();
      text = "rules " + rules.join(", ") + ", and " + last_rule;
    }
    return text;
  }

  check_original(index, field) {
    let row = this.get_row(index);
    let row_key = this.get_row_key(index, field);
    let original;
    if (this.original_relationships[index]) {
      original = this.original_relationships[index];
    }
    else {
      original = this.get_new_row();
    }

    if (this.$scope.relationship_form[row][row_key].$modelValue !== original[field]) {
      this.$scope.relationship_form[row][row_key].$setDirty();
    }
    else {
      this.$scope.relationship_form[row][row_key].$setPristine();

      let pristine = true;
      for (let key in original) {
        let row_key = this.get_row_key(index, key);
        if (this.$scope.relationship_form[row].hasOwnProperty(row_key)) {
          if (this.$scope.relationship_form[row][row_key].$modelValue !== original[key]) {
            pristine = false;
            break;
          }
        }
      }

      if (pristine) {
        this.$scope.relationship_form[row].$setPristine();
        this.check_form();
      }
    }

    this.validate_rules();
  }

  check_user_validation() {
    for (let i in this.$scope.relationships) {
      let row = this.get_row(i);
      if (this.$scope.relationship_form && this.$scope.relationship_form[row]) {
        // TODO This causes an "Infinite $digest Loop", but it's otherwise needed to set the $pristine/$dirty status
        //for (let field of ['gp', 'pharmacist', 'relationship_type', 'reason']) {
        //  this.check_original(i, field);
        //}

        let index;

        index = this.$scope.error.indexOf(this.$scope.relationship_form[row].relationship_type);
        if (index !== -1) {
          this.$scope.error.splice(index, 1);
        }

        if (Object.keys(this.$scope.relationship_form[row].relationship_type.$error).length) {
          this.$scope.error.push(this.$scope.relationship_form[row].relationship_type);
        }

        index = this.$scope.error.indexOf(this.$scope.relationship_form[row].reason);
        if (index !== -1) {
          this.$scope.error.splice(index, 1);
        }

        if (Object.keys(this.$scope.relationship_form[row].reason.$error).length) {
          this.$scope.error.push(this.$scope.relationship_form[row].reason);
        }
      }
    }

    if (this.$scope.error.length) {
      this.$scope.valid = false;
      this.$scope.invalid = true;
    }
    else {
      this.$scope.valid = true;
      this.$scope.invalid = false;
    }
  }

  revert_relationship(index) {
    let row = this.get_row(index);
    let original;
    if (this.original_relationships[index]) {
      original = this.original_relationships[index];
    }
    else {
      original = this.get_new_row();
    }

    for (let key in original) {
      if (original.hasOwnProperty(key)) {
        this.$scope.relationships[index][key] = original[key];
      }
    }
    this.$scope.relationship_form[row].$setPristine();
    this.check_form();
  }

  check_form() {
    let pristine = true;

    if (this.$scope.relationships.length !== this.original_relationships.length) {
      pristine = false;
    }
    else {
      for (let i = 0; i < this.$scope.relationships.length; ++i) {
        let row = this.get_row(i);
        if (this.$scope.relationship_form[row].$dirty) {
          pristine = false;
          break;
        }
      }
    }

    if (pristine) {
      this.$scope.relationship_form.$setPristine();
    }
  }

  get_new_row() {
    return {
      id: null,
      clinic: this.$scope.clinic,
      gp: this.any_gp,
      pharmacist: this.any_pharmacist,
      relationship_type: this.$scope.no_relationship_type,
      reason: "",
    };
  }

  get_row(index) {
    return "row[" + index + "]";
  }

  get_row_key(index, key) {
    return key;
  }
}

ClinicRelationshipController.$inject = $inject;
export default ClinicRelationshipController;



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/admin/controllers/clinic-relationship.controller.js
 **/